import { render, staticRenderFns } from "./TransactionVolume.vue?vue&type=template&id=2406a5aa"
import script from "./TransactionVolume.vue?vue&type=script&lang=js"
export * from "./TransactionVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports